import {Injectable} from '@angular/core';
import * as CryptoJS from 'crypto-js';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SingletonSecureStorageService {

  constructor() {
  }

  init() {

    if (environment.production === false) {
      return;
    }

    const privateKey = 'MIICXgIBAAKBgQC3uaEUySk0sIX561zKU34CvL3RlfifX8XGIAmJ3g5wvbVXWx6pHbc';
    Storage.prototype._setItem = Storage.prototype.setItem;
    Storage.prototype._getItem = Storage.prototype.getItem;

    Storage.prototype.setItem = function(key, value) {
      this._setItem(key, CryptoJS.AES.encrypt(value, privateKey).toString());
    };

    Storage.prototype.getItem = function(key) {
      try {
        let value = this._getItem(key);
        if (value) {
          return CryptoJS.AES.decrypt(value, privateKey).toString(CryptoJS.enc.Utf8);
        } else {
          return null;
        }
      } catch (e) {
        console.log(e);
        localStorage.clear();
        window.location.reload();
      }
    };
  }
}
